import { Typography, Box, AppBar, Tabs, Tab } from "@mui/material";
import { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import FeedbackTab from "./Tabs/FeedbackTab";
import HistoryTab from './Tabs/HistoryTab';
import CommentsTab from './Tabs/CommentsTab';
import SummaryTab from './Tabs/SummaryTab';
import { useAuth0 } from "@auth0/auth0-react";

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (<div role="tabpanel" hidden={value !== index} id={`scrollable-auto-tabpanel-${index}`} aria-labelledby={`scrollable-auto-tab-${index}`} {...other}>
        {value === index && (<Box p={3}>
            <Typography>{children}</Typography>
        </Box>)}
    </div>);
}
TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};
function a11yProps(index) {
    return {
        id: `scrollable-auto-tab-${index}`,
        'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
}
const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
}));

const SimpleTabs = ({ requestData, setRequestData, notes, histories, feedbacks, setSnackbarOpen, setSnackbarMsg, setLoading }) => {
    const { user, isAuthenticated } = useAuth0();
    const classes = useStyles();
    const [tabValue, setTabValue] = useState(0);

    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };

    return (<div className={classes.root}>
        <AppBar position="static">
            <Tabs value={tabValue} onChange={handleChange} aria-label="simple tabs example" variant="scrollable" scrollButtons="auto">
                <Tab label="Summary" value={0} {...a11yProps(0)} />
                {(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("request-note:read")) > -1 && <Tab label="Comments" value={2} {...a11yProps(2)} />}
                {(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("request-history:read")) > -1 && <Tab label="History" value={3} {...a11yProps(3)} />}
                {(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("request-feedback:read")) > -1 && <Tab label="Feedback" value={4} {...a11yProps(4)} />}
            </Tabs>
        </AppBar>

        <TabPanel value={tabValue} index={0}>
            <SummaryTab requestData={requestData} setRequestData={setRequestData.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} setLoading={setLoading.bind(this)} />
        </TabPanel>
        {(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("request-note:read")) > -1 && <TabPanel value={tabValue} index={2}>
            <CommentsTab notes={notes} requestData={requestData} setRequestData={setRequestData.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} setLoading={setLoading.bind(this)} />
        </TabPanel>}
        {(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("request-history:read")) > -1 && <TabPanel value={tabValue} index={3}>
            <HistoryTab histories={histories} />
        </TabPanel>}
        {(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("request-feedback:read")) > -1 && <TabPanel value={tabValue} index={4}>
            <FeedbackTab feedbacks={feedbacks} />
        </TabPanel>}
    </div>);
}

export default SimpleTabs;